import { useContext } from 'react'
import { Box, Text, ErrorSummary } from '@postenbring/hedwig-react'
import { InputsContext } from '../InputsContext'

export const ResultDisplay = ({ labels }) => {
    const {
        error,
        zoneCount,
    } = useContext(InputsContext)

  return (
    <>
    <Box style={{backgroundColor: "white"}}>
        {error && (
            <ErrorSummary aria-live="polite">
                <ErrorSummary.Heading as='h3'>{error}</ErrorSummary.Heading>
            </ErrorSummary>
        )}
        {zoneCount && (
            <>
                <Text variant="body-title">
                    {labels.zoneCountTextStart}
                </Text>
                <Text className="hds-mt-16-20">
                    <hr style={{ margin: '16px 0', border: 0, borderTop: '1px solid #ccc' }} />
                    {zoneCount} {labels.zoneCountText}
                </Text>
            </>
        )}
    </Box>
    </>
  )
}
